import { getAuthHeaders } from './auth';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const updateLocation = async (latitude, longitude) => {
  const response = await fetch(`${API_URL}/api/location`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify({ latitude, longitude })
  });
  
  if (!response.ok) {
    throw new Error('Failed to update location');
  }
  
  return response.json();
};

export const getLastLocation = async () => {
  const response = await fetch(`${API_URL}/api/location/last`, {
    headers: getAuthHeaders()
  });
  
  if (!response.ok) {
    throw new Error('Failed to get location');
  }
  
  return response.json();
};
